module.exports = __webpack_public_path__ + "media/images/sp/register/btn_charica_register-64b8eb0491ad0a7275662f5fec46c827.png";